<template>
  <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g opacity="0.5">
      <path
        d="M71.9801 14.6484H9.5745C8.73257 14.649 7.92528 14.9836 7.32995 15.579C6.73462 16.1743 6.39994 16.9816 6.39941 17.8235V75.0812C6.39994 75.9231 6.73462 76.7304 7.32995 77.3258C7.92528 77.9211 8.73257 78.2558 9.5745 78.2563H71.9801C72.8221 78.2559 73.6294 77.9212 74.2248 77.3259C74.8202 76.7305 75.155 75.9232 75.1555 75.0812V17.8235C75.155 16.9815 74.8202 16.1742 74.2248 15.5789C73.6294 14.9835 72.8221 14.6489 71.9801 14.6484Z"
        fill="#777777"
      />
      <path
        d="M67.8719 58.3602H13.6834C11.9299 58.3602 10.5083 56.9386 10.5083 55.1852V4.595C10.5083 2.84156 11.9299 1.41992 13.6834 1.41992H67.8719C69.6254 1.41992 71.047 2.84156 71.047 4.595V55.1852C71.047 56.9386 69.6254 58.3602 67.8719 58.3602Z"
        fill="#A8A8A8"
      />
      <path
        d="M11.5135 56.1901V5.60025C11.5135 3.84681 12.9352 2.42517 14.6886 2.42517H68.8772C69.4965 2.42517 70.0722 2.60517 70.5604 2.91173C69.9991 2.01664 69.0063 1.41992 67.8719 1.41992H13.6834C11.9299 1.41992 10.5083 2.84156 10.5083 4.595V55.1852C10.5083 56.3199 11.105 57.3124 12.0001 57.874C11.6935 57.3855 11.5135 56.8098 11.5135 56.1904V56.1901Z"
        fill="url(#paint0_linear_2122_42518)"
      />
      <path
        d="M61.205 12.1084H20.3516V14.4366H61.205V12.1084ZM61.205 20.9982H20.3516V23.3264H61.205V20.9982ZM61.205 29.89H20.3516V32.2182H61.205V29.89ZM61.205 38.7799H20.3516V41.1084H61.205V38.7799Z"
        fill="white"
      />
      <path
        d="M25.2197 31.2656L35.4856 41.5319H25.2197V31.2656Z"
        fill="url(#paint1_linear_2122_42518)"
      />
      <path d="M75.1559 42.3779V18.7573L71.0474 14.6484V42.3776H75.1559V42.3779Z" fill="#777777" />
      <path
        d="M79.9682 44.5152L75.5416 75.8503C75.3203 77.4169 73.9796 78.5811 72.3977 78.5811H9.15767C7.57571 78.5811 6.23505 77.4169 6.01374 75.8503L0.0317719 33.509C-0.238064 31.5975 1.24521 29.8896 3.17571 29.8896H22.7055C24.2875 29.8896 25.6282 31.0539 25.8495 32.6201L26.6334 38.1651C26.8547 39.7316 28.1954 40.8959 29.7773 40.8959H76.8249C78.7547 40.8959 80.238 42.6037 79.9682 44.5152Z"
        fill="url(#paint2_linear_2122_42518)"
      />
      <path
        d="M64.2844 64.6035H17.2716C17.0139 64.6034 16.7651 64.5094 16.5718 64.339C16.3785 64.1686 16.2539 63.9336 16.2214 63.6779L15.6332 59.0209C15.6145 58.8719 15.6278 58.7207 15.672 58.5772C15.7162 58.4337 15.7904 58.3013 15.8897 58.1886C15.9891 58.076 16.1112 57.9858 16.248 57.924C16.3848 57.8622 16.5333 57.8302 16.6834 57.8301H64.8726C65.0227 57.8302 65.1711 57.8622 65.308 57.924C65.4448 57.9858 65.5669 58.076 65.6662 58.1886C65.7655 58.3013 65.8398 58.4337 65.884 58.5772C65.9282 58.7207 65.9414 58.8719 65.9227 59.0209L65.3345 63.6779C65.3021 63.9336 65.1775 64.1686 64.9842 64.339C64.7909 64.5094 64.5421 64.6034 64.2844 64.6035Z"
        fill="#D5D5D5"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2122_42518"
        x1="42.6395"
        y1="31.7484"
        x2="2.48535"
        y2="-8.40598"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D0D0D0" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2122_42518"
        x1="32.0024"
        y1="43.1791"
        x2="19.5935"
        y2="30.7705"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#C2CECE" stop-opacity="0" />
        <stop offset="0.179" stop-color="#AFBCBC" stop-opacity="0.179" />
        <stop offset="1" stop-color="#5B6A6A" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2122_42518"
        x1="40"
        y1="29.8896"
        x2="40"
        y2="78.5811"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FCFCFD" />
        <stop offset="0.927" stop-color="#FDFDFD" />
      </linearGradient>
    </defs>
  </svg>
</template>
